var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.caption)?_c('span',{class:['badge', `badge--${_vm.type}`]},[_vm._v(" "+_vm._s(_vm.caption)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }